import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from '../../common/modules/core';
import { UserModule } from '../../common/modules/user';

import { AppComponent } from './AppComponent';
import { routing } from './AppRouting';
// Modules
import { BusAttendanceModule } from './bus-attendance/BusAttendanceModule';
import { ChildrenListModule } from './children-list/ChildrenListModule';

// Service
import { BusServices } from '../services/BusServices';
import { ChildrenServices } from '../services/ChildrenServices';
import { LocationServices } from '../services/LocationServices';

@NgModule({
    imports: [
        BrowserModule,
        CoreModule,
        UserModule,
        BusAttendanceModule,
        ChildrenListModule,
        routing
    ],
    declarations: [
        AppComponent,
    ],
    providers: [
        BusServices,
        ChildrenServices,
        LocationServices
    ],
    bootstrap: [
        AppComponent,
    ]
})

export class AppModule {}


// WEBPACK FOOTER //
// ./src/bus/parent/AppModule.ts